import { useEffect } from 'react'
import { subscribeTagReads } from '../services/scannerService'
import { useBirthScanStore } from '../stores/birthScanStore'

/** Hardware TagRead → Engine birth scan pool. */
export function useBirthScanSubscription(enabled: boolean) {
  const ingestTag = useBirthScanStore((s) => s.ingestTag)

  useEffect(() => {
    if (!enabled) return
    return subscribeTagReads((tagId) => ingestTag(tagId))
  }, [enabled, ingestTag])
}
